// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-activities-filter__control{width:100%;max-width:100%;margin:0}.h-activities-filter__control+.h-activities-filter__control{margin-top:24px}@media (max-width:767px){.h-activities-filter__control .h-select__box{width:100%}}@media (min-width:768px){.h-activities-filter__control .h-select__box{width:280px}}", ""]);
// Exports
module.exports = exports;
